var map = {
	"./0.jpg": 1359,
	"./1.jpg": 7097,
	"./10.jpg": 1645,
	"./11.jpg": 7822,
	"./12.jpg": 2317,
	"./13.jpg": 8786,
	"./14.jpg": 6217,
	"./15.jpg": 2581,
	"./2.jpg": 7253,
	"./3.jpg": 9672,
	"./4.jpg": 2668,
	"./5.jpg": 1279,
	"./6.jpg": 6245,
	"./7.jpg": 9511,
	"./8.jpg": 1355,
	"./9.jpg": 3187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;